import { css } from 'lit';

export const shareFileModalStyles = css`

.wrapper {
    opacity: 0;
    transition: opacity 0.25s ease-in;
    z-index: 20;
    will-change: opacity;
  }

  .wrapper:not(.open) {
    visibility: hidden;
  }

  .wrapper.open {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 1;
    visibility: visible;
  }

  .overlay {
    padding: 0px 160px;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .modal {
    width: 600px;
    min-height: 538px;
    font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", "Geneva", "Verdana", "sans-serif";
    background-color: #F5F5F5;
    border: 1px solid #DCDCDC;
    border-radius: 8px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
    padding: 25px;
    margin: 30px auto 0;
    font-size: 16px;
    display: block;
  }

  .header {
    color: #666666;
    border-bottom: 1px solid #979797;
    border-radius: 0;
    margin: 0px 0 20px;
    padding: 0 0 3px 0;
    font-size: 14px;
    font-weight: normal;
    text-transform: normal;
    line-height: 1em;
    text-align: left;
  }

  .header-icon {
    width: 25px;
    height: 25px;
    padding-right: 10px;
    padding-bottom: 3px;
  }

  .title {
    flex-grow: 1;
  }

  .header .close-icon {
    margin-left: auto;
  }

  .content {
    margin: 10px 40px 0;
  }

  .spacer {
    width: 24px;
  }

  .divider {
    height: 1px;
    background-color: #ccc;
    margin: 10px 5px;
  }

  .label {
    font-size: 12px;
    font-weight: normal;
    text-align: left;
  }

  .dropdown {
    position: relative;
    display: inline-block;
    cursor: pointer;
    min-width: 75px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: white;
  }

  .dropdown.open .dropdown-indicator {
    transform: rotate(180deg);
  }

  .dropdown span {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: none;
    padding: 4px 10px;
  }

  .dropdown span svg {
    width: 20px;
    height: 20px;
    fill: currentColor;
    display: inline-block;
    transition: transform 0.2s ease;
  }

  .dropdown.open span svg {
    transform: rotate(180deg);
  }

  .dropdown:first-child {
    flex: 0.8;
  }

  .dropdown:last-child {
    flex: 2.2;
  }

  .dropdown-section {
    display: flex;
    gap: 20px;
    margin-bottom: 2px;
    font-size: 14px;
    font-weight: normal;
  }

  .dropdown-indicator {
    margin-left: 8px;
    width: 14px;
    height: 14px;
    transform: rotate(0);
    transition: transform 0.2s ease;
    display: inline-block;
  }

  .dropdown.open .dropdown-indicator {
    transform: rotate(180deg);
  }

  .dropdown-options,
  .dropdown-options-low {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 0;
    margin: 0;
    list-style: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 101;
    transform-origin: top;
    transform: scaleY(0);
    transition: transform 0.2s ease;
  }

  .dropdown-options-low {
    width: 150px;
    display: none;
    transform-origin: bottom;
    z-index: 10;
  }

  .dropdown-options.open,
  .dropdown-options-low.open {
    display: block;
    transform: scaleY(1);
  }

  .dropdown-options li,
  .dropdown-options-low li {
    padding: 6px 10px;
    cursor: pointer;
    font-size: 9pt;
    display: flex;
    align-items: center;
  }

  .dropdown-options li:hover,
  .dropdown-options-low li:hover {
    background: #f0f0f0;
  }

  .dropdown-options li label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
  }

  .dropdown-options li input[type="checkbox"],
  .dropdown-options-low li input[type="checkbox"] {
    width: 18px;
    height: 18px;
    border: 2px solid #438BDF;
    border-radius: 4px;
    appearance: none;
    outline: none;
    cursor: pointer;
    transition: border-color 0.2s ease, background-color 0.2s ease;
    position: relative;
  }

  .dropdown-options li input[type="checkbox"]:checked,
  .dropdown-options-low li input[type="checkbox"]:checked {
    background-color: #438BDF;
    border-color: #033F86;
  }

  .dropdown-options li input[type="checkbox"]::after,
  .dropdown-options-low li input[type="checkbox"]::after {
    content: '';
    position: absolute;
    top: calc(50% - 2px);
    left: 50%;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: translate(-50%, -50%) rotate(45deg);
    display: none;
  }

  .dropdown-options li input[type="checkbox"]:checked::after,
  .dropdown-options-low li input[type="checkbox"]:checked::after {
    display: block;
  }

  .add-button {
    width: calc(100% - 20px);
    background: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 6px 10px;
    font-size: 14px;
    text-align: left;
    cursor: pointer;
    margin: 0;
  }

  .add-button:hover {
    background: #f9f9f9;
  }

  .list.add-account,
  .list.shared-accounts {
    max-height: 400px;
    min-height: 300px;
    overflow-y: auto;
    scrollbar-gutter: stable;
    border: none;
    border-radius: 4px;
    padding: 10px 40px 0px 0px;
  }

  .list.add-account {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    padding: 10px 0px 0px 0px;
  }

  .list.shared-accounts {
    margin-top: 5px;
    padding-right: 20px;
  }

  .list.add-account::-webkit-scrollbar,
  .list.shared-accounts::-webkit-scrollbar {
    width: 8px;
  }

  .list.add-account::-webkit-scrollbar-thumb,
  .list.shared-accounts::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 4px;
  }

  .list.add-account::-webkit-scrollbar-track,
  .list.shared-accounts::-webkit-scrollbar-track {
    background-color: #f9f9f9;
  }

  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
  }

  .add-account-container {
    display: flex;
    flex-direction: column;
    max-height: 400px;
    overflow: hidden;
    height: 100%;
    position: relative;
  }

  .scrollable-section {
    flex-grow: 1;
    overflow-y: auto;
    padding: 10px 20px 10px 10px;
  }

  .scrollable-section::-webkit-scrollbar {
    width: 8px;
  }

  .scrollable-section::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 4px;
  }

  .scrollable-section::-webkit-scrollbar-track {
    background-color: #f9f9f9;
  }

  .fixed-bottom-section {
    position: sticky;
    bottom: 0;
    padding: 10px 40px;
    background: white;
    border-top: 1px solid #ccc;
    z-index: 1;
  }

  .accounts-section {
    margin-top: 20px;
  }

  .accounts-table {
    display: flex;
    flex-direction: column;
    border: 1px solid #ccc;
    border-radius: 4px;
    overflow: hidden;
    background: #f9f9f9;
    width: 100%;
    height: 284px;
  }

  .table-header {
    display: flex;
    background: white;
    border-bottom: 1px solid #ccc;
    font-weight: normal;
    font-size: 14px;
  }

  .table-column {
    padding: 10px;
    flex: 1;
    text-align: left;
  }

  .account-column {
    flex: 2;
  }

  .access-column {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .table-body {
    flex-grow: 1;
    background: #f9f9f9;
    overflow-y: auto;
    position: relative;
  }

  .table-body::-webkit-scrollbar {
    width: 8px;
  }

  .table-body::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 4px;
  }

  .table-body::-webkit-scrollbar-track {
    background-color: #f9f9f9;
  }

  .table-row {
    display: flex;
    border-bottom: 1px solid #ccc;
    font-size: 14px;
    align-items: center;
    background: #f9f9f9;
  }

  .table-row:last-child {
    border-bottom: none;
  }

  .table-footer {
    display: flex;
    background: white;
    height: 40px;
    border-top: 1px solid #ccc;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  }

  .trash-icon {
    cursor: pointer;
    margin-left: 10px;
    color: #438BDF;
    font-size: 16px;
    vertical-align: middle;
    display: flex;
    align-items: center;
  }

  .trash-icon:hover {
    color: #357ABD;
  }

  .main-account {
    font-weight: normal;
    background: #f9f9f9;
    pointer-events: none;
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding: 20px 0;
    position: relative;
    z-index: 1;
    max-width: 500px;
    margin: 24px auto 0;
    text-align: center;
  }

  .btn {
    width: 150px;
    margin: 0 6px;
    padding: 8px 10px;
    border-radius: 8px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
    outline: none;
    line-height: 1em;
    display: inline-block;
    cursor: pointer;
    font-size: 16px;
    text-transform: normal;
    transition: background-color 0.2s, color 0.2s;
  }

  .btn.cancel {
    color: #5B5B5B;
    border: 1px solid #979797;
    background-color: white;
  }

  .btn.cancel:hover {
    background-color: #f9f9f9;
  }

  .btn.primary {
    color: #FFFFFF;
    border: 1px solid #438bdf;
    background-color: #438BDF;
  }

  .btn.primary:hover {
    background-color: #357abd;
  }

  .btn.save:hover {
    background-color: #357abd;
  }

  button {
    margin-top: 10px;
    padding: 10px 20px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  button.cancel {
    background: #ccc;
  }

  button:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }

`;